import baseApi from './baseApi';

export type AdminOnboardingType = 'car_dealership' | 'insurance_broker' | 'financial_institution' | 'after_sales';

export interface AdminOnboardingNewCompanyRequest {
  mode: 'newCompany';
  businessUnitName: string;
  businessUnitPhoneNumber?: string;
  type: AdminOnboardingType;
  company: {
    name: string;
    domains?: string[];
    whatsappGroupJid?: string;
  };
  setupNotion: boolean;
}

export interface AdminOnboardingExistingCompanyRequest {
  mode: 'existingCompany';
  businessUnitName: string;
  businessUnitPhoneNumber?: string;
  type: AdminOnboardingType;
  companyId: number;
  scaffoldNotionForBu: boolean;
}

export type AdminOnboardingRequest = AdminOnboardingNewCompanyRequest | AdminOnboardingExistingCompanyRequest;

export interface AdminOnboardingResponse {
  ok: boolean;
  company: { id: number; name: string };
  businessUnit: { id: number; name: string; type: AdminOnboardingType; phoneNumber: string };
  notion: {
    setupRan: boolean;
    scaffolded: boolean;
    scaffoldSkipped: boolean;
    error?: string;
    mainPageId?: string;
    buPageId?: string;
  };
}

export interface AdminCompanySummary {
  id: number;
  name: string;
  domains: string[] | null;
  notionConfig: { mainPageId?: string; businessUnitsDbId?: string } | null;
}

const adminOnboardingApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createAdminOnboardingBusinessUnit: build.mutation<AdminOnboardingResponse, AdminOnboardingRequest>({
      query: (data) => ({
        url: '/admin/onboarding/business-unit',
        method: 'POST',
        body: data,
      }),
    }),
    getAdminCompanies: build.query<AdminCompanySummary[], void>({
      query: () => ({ url: '/admin/companies', method: 'GET' }),
    }),
  }),
  overrideExisting: false,
});

export const { useCreateAdminOnboardingBusinessUnitMutation, useGetAdminCompaniesQuery } = adminOnboardingApi;
